export default "__VITE_ASSET__BW4Ojj$0__"